import { render } from "./TechnologyBlock.vue?vue&type=template&id=64398630&scoped=true"
import script from "./TechnologyBlock.vue?vue&type=script&lang=js"
export * from "./TechnologyBlock.vue?vue&type=script&lang=js"

import "./TechnologyBlock.vue?vue&type=style&index=0&id=64398630&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64398630"]])

export default __exports__